import { Link, useNavigate } from "react-router-dom";
import { VerifyEmailForm } from "wasp/client/auth";
import { AuthPageLayout } from "../AuthPageLayout";
import { useEffect } from "react";
import { useQuery, validateUser } from "wasp/client/operations";
import { useAuth, login } from "wasp/client/auth";
import { Button } from "../../components/ui/button";
import { ArrowRight } from "lucide-react";

export function EmailVerificationPage() {
  const navigate = useNavigate();

  const handleGetStarted = async () => {
    const username = localStorage.getItem("username");
    const password = localStorage.getItem("password");
    
    if (username?.length && password?.length) {
      try {
        await login({
          email: username,
          password: password,
        });
        localStorage.removeItem("username");
        localStorage.removeItem("password");
        navigate("/admin");
      } catch (error) {
        console.error("Login failed:", error);
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <AuthPageLayout
    twoColumn={false}
    >
      <VerifyEmailForm />
      <div className="w-full mt-6 space-y-4">
        <Button
          onClick={handleGetStarted}
          className="w-full h-14 text-lg font-medium  hover:bg-gray-700 text-white rounded-xl"
        >
          <span className="flex items-center justify-center gap-2">
            Get Started
            <ArrowRight className="w-5 h-5" />
          </span>
        </Button>
        <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
          Click to continue to your dashboard
        </p>
      </div>
    </AuthPageLayout>
  );
}